/**
 * People lists (Clients, Leads, Team, Vendors) are server-driven lists of MEMBERSHIPS (`client_member`, `lead_member`, `team_member`,
 * `vendor_member`: backend modules/people/entity-config.js) with the person embedded as `user`. This maps one row to the flat
 * person shape the screens use: the id is the PERSON's id (what the forms, the user endpoints and the exports use); the membership
 * contributes the role / active flag and the document counter the server computed.
 */
export interface MemberRow {
  id: string;
  user_id: string;
  role: string;
  is_active: boolean;
  attachment_count?: number;
  /** vendor memberships only: the cost codes the vendor works on (phase194) */
  cost_code_ids?: string[] | null;
  user: Record<string, any> | null;
}

export function mapMember<T = Record<string, any>>(row: MemberRow): T {
  const user = row.user ?? {};
  return {
    ...user,
    id: row.user_id,
    role: row.role,
    is_active: row.is_active ?? true,
    attachment_count: row.attachment_count ?? 0,
    ...(row.cost_code_ids !== undefined ? { cost_code_ids: row.cost_code_ids ?? [] } : {}),
  } as T;
}
